module.exports = __webpack_public_path__ + "static/img/26820.b1bee3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/jys/26820.png
// module id = S3yp
// module chunks = 0